import React, { Component } from 'react';
import Spinner from '../../components/UI/Spinner/Spinner';
import axios from '../../axios-ns';
import Aux from '../../hoc/Aux';
import * as messages from '../../messages';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import classes from './../../index.css';
import MoodIcon from '@material-ui/icons/Mood';

class Activation extends Component {
    state = {
        loading: true,
        message: null
    }

    componentDidMount() {
        axios.get('activate/' + this.props.match.params.code)
            .then(response => {
                this.setState({ loading: false, message: messages['ACCOUNT_ACTIVATED'], error: null });
            }).catch(err => {
                this.setState({ loading: false, message: null, error: messages[err.response.data.message] });
            });
    }

    render() {
        let activationStatus = this.state.loading ? null : <div><p style={{ color: '#f50057' }}>{this.state.error}</p> {this.state.message}</div>;

        let view = this.state.loading ? <Spinner /> : (<Card style={{textAlign: 'center'}}>
            <CardHeader title={messages.ACCOUNT_ACTIVATED_HEAD} className={classes.Head}/>
            <p style={{textAlign: 'center', padding: '10px'}}>
                <MoodIcon style={{fontSize: '50px'}}/>
                {activationStatus}
                <Button color="primary" href="../signin" type="button" style={{ marginBottom: '35px' }}>
                    {messages.SIGNIN}
                </Button>
            </p>
        </Card>);

        return <Aux>{view}</Aux>;
    }
}

export default Activation; 